<template>
  <div>
    <div class="card mb-3" v-if="!isEditing">
      <div class="card-body">
        <h4 class="card-title">Kreiraj novi projekat</h4>
        <form>
          <div class="form-group mb-3">
            <label>Akronim</label>
            <input type="text" name="name" v-model="project.name" class="form-control" />
          </div>
          <div class="mt-2">
            <button type="button" class="btn btn-success" @click.prevent="saveProject">
              <i class="fas fa-save"></i>
              Sačuvaj
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="card mb-3" v-else>
      <div class="card-body">
        <h4 class="card-title">Izmeni projekat</h4>
        <form>
          <div class="form-group mb-3">
            <label>Akronim</label>
            <input type="text" name="name" v-model="project.name" class="form-control" />
          </div>
          <div class="mt-2">
            <button type="button" class="btn btn-success" @click.prevent="updateProject">
              <i class="fas fa-save"></i>
              Sačuvaj
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary"
              v-if="isEditing"
              @click.prevent="cancelEdit"
            >Odustani</button>
          </div>
        </form>
      </div>
    </div>
    <div class="card mb-3">
      <div class="card-body">
        <h4 class="card-title">Kreiraj novi projekat</h4>
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Akronim</th>
              <th width="200">Opcije</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="project in projects" :key="project.id">
              <td>{{ project.name }}</td>
              <td>
                <button
                  class="btn btn-sm btn-outline-primary"
                  @click.prevent="setProject(project,$event)"
                >Izmeni</button>
                <button
                  class="btn btn-sm btn-outline-danger"
                  @click.prevent="deleteProject(project)"
                >Obriši</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["projects"],
  data() {
    return {
      isEditing: false,
      showModal: false,
      project: {}
    };
  },
  methods: {
    saveProject(event) {
      if (this.project.name !== undefined) {
        console.log(this.project.name);
        axios
          .post(this.$Laravel.apiURL + "/projects", {
            name: this.project.name
          })
          .then(response => {
            console.log(response);
            this.projects.push(response.data);
            this.project = {};
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    updateProject(event) {
      //console.log(this.project.id, this.project.name);
      if (this.project.name !== undefined) {
        console.log(this.project.name);
        axios
          .put(this.$Laravel.apiURL + "/projects/" + this.project.id, {
            name: this.project.name
          })
          .then(response => {
            ///console.log(response);
            let index = this.projects
              .map(item => item.id)
              .indexOf(this.project.id);
            //console.log(index);
            this.projects[index] = response.data;
            this.project = {};
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    cancelEdit() {
      this.project = {};
      this.isEditing = false;
    },
    setProject(project, event) {
      //console.log(project);
      this.isEditing = true;
      this.project = { ...project };
    },
    deleteProject(project, event) {
      let confirm = window.confirm(
        "Da li želite da obrišete projekat " + project.name
      );
      if (confirm) {
        axios
          .delete(this.$Laravel.apiURL + "/projects/" + project.id)
          .then(response => {
            ///console.log(response);
            let index = this.projects
              .map(item => item.id)
              .indexOf(project.id);
            //console.log(index);
            this.projects.splice(index, 1);            
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  }
};
</script>

<style>
</style>